import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentEntity } from '../../domain/entities/ShipmentEntity'
import type { ShipmentAdminDto } from '@/backend/market'
export class ShipmentModel extends ShipmentEntity {
  constructor(dataDto: ShipmentAdminDto) {
    super()
    mapEntityProperties<ShipmentEntity>(this, dataDto, {
      map: {
        tags: dataDto.orderTags,
        invoice: dataDto.orderInvoice,
        discount: dataDto.orderDiscount
      }
    })
  }
}
